import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

firebase.initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API,
    authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE
});

if ( process.env.REACT_APP_NODE_ENV !== 'production' ) {
    window.firebase = firebase;
}

export default firebase;



// WEBPACK FOOTER //
// ./src/library/firebase.js